export enum PaymentState {
  CREATED = 1,
  CANCELLED = 2,
  FAILED = 64,
  AUTHORIZED = 128,
  REFUNDED = 250,
  PARTIALLYCAPTURED = 254,
  CAPTURED = 255,
}

export enum PaymentType {
  ONLINE = 0,
  GIFTCARD = 1,
  UNPAID = 2,
}
